import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'
import GLightbox from 'glightbox'

class GallerySection extends Section {
  init() {
    this.lightboxSetup()
  }

  lightboxSetup() {
    if (!this.refs.images?.length) {
      return
    }

    this.refs.images.forEach((el, i) => {
      on(el, 'pointerup', () => {
        const elements = this.lightboxImages()
        const gallery = GLightbox({
          elements,
          startAt: i
        })
        gallery.open()
      })
    })
  }

  lightboxImages() {
    if (!this.refs.images?.length) {
      return
    }

    const items = []
    this.refs.images.forEach((el) => {
      const source = el.querySelector('source:last-of-type')
      if (source) {
        items.push({
          href: source.src,
          type: 'image'
        })
      }
    })
    return items
  }
}

register('gallery', GallerySection)
